import React, { useState } from 'react'
import CustomRadio from '../../components/UI/radio/CustomRadio';
import { setErrorButton } from '../../store/buttonSlice';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default function TargetContent({ checkboxes, setCheckboxes, error, setDisabled, setError, setValue, setTargetId }) {

    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(null);

    const handleCheckboxChange = (checkbox) => {
        setSelectedOption(checkbox.id);
        setDisabled(false)
        setError(false);
        dispatch(setErrorButton(false))
        setValue(checkbox.text)
        setTargetId(checkbox.id)
    };

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('current-id');



    const goal1 = id === '0' ? checkboxes.slice(id) : checkboxes.slice(0, -(checkboxes.length - id))
    const goal2 = (id === '4' || id === '5') ? checkboxes.slice(2) : (id === '3' || id === '2') ? checkboxes.slice(1) : checkboxes.slice(0)
    const goal3 = (id === '5') ? checkboxes.slice(4) : ( id === '4') ? checkboxes.slice(3) : (id === '3') ? checkboxes.slice(2) : (id === '2') ? checkboxes.slice(1) : checkboxes.slice(0)

    const goalProductivuty1 = (id === '4' || id === '5' || id === '3') ? checkboxes.slice(0) : (id === '2') ? checkboxes.slice(0, - 1) : checkboxes.slice(0, - (checkboxes.length - 3 - id))
    const goalProductivuty2 = (id === '4' || id === '5') ? checkboxes.slice(5) : (id === '3') ? checkboxes.slice(3) : (id === '2') ? checkboxes.slice(2) : checkboxes.slice(0)
    const goalProductivuty3 = (id === '4' || id === '5') ? checkboxes.slice(0) : (id === '3') ? checkboxes.slice(0, - 1) : (id === '2') ? checkboxes.slice(0, - 2) : checkboxes.slice(0, - (checkboxes.length - 2 - id))
    const goalProductivuty5 =  checkboxes.slice(0, - (checkboxes.length - 7 - id))

    const slice = queryParams.get('goals') === '1' ? goal1
        : queryParams.get('goals') === '2' ? goal2
            : queryParams.get('goals') === '3' ? goal3
                : queryParams.get('productivity-goals-id') === '1' ? goalProductivuty1
                    : queryParams.get('productivity-goals-id') === '2' ? goalProductivuty2
                        : queryParams.get('productivity-goals-id') === '3' ? goalProductivuty3
                            : queryParams.get('productivity-goals-id') === '5' ? goalProductivuty5
                                : checkboxes.slice(id)
    return (
        <>
            {checkboxes && slice?.map((checkbox) => (
                checkbox.text !== '' &&
                <CustomRadio
                    key={checkbox.id}
                    id={checkbox.id}
                    checked={selectedOption === checkbox.id}
                    onChange={() => handleCheckboxChange(checkbox)}
                    className={error ? 'error' : undefined}
                    style={{ marginBottom: '8rem' }}
                >
                    {checkbox.text}
                </CustomRadio>
            ))}
        </>
    )
}
